<div class="form-group" *ngIf="checkViewMode('edit')">
    <label for="">
      <span class="red-text">{{ attribute.key }} </span>
      <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
      <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info"
      [popover]="getOptionByKey(attribute,'tooltip')"
      placement="right"
      container="body"
      triggers="mouseenter:mouseleave">
        <i class="fa fa-question-circle"></i>
      </div>
    </label>
    <ng-select
      [id]="getOptionByKey(attribute,'identifier')"
      [items]="unidades"
      [disabled]="getOptionByKey(attribute,'disabled')"
      [required]="getOptionByKey(attribute,'required')"
      bindValue="key"
      bindLabel="value"
      [tabindex]="getOptionByKey(attribute,'tabIndex')"
      placeholder="{{ placeholder }}"
      (change)="changedSelect()"
      [(ngModel)]="attribute.value">
    </ng-select>
  </div>
  <div class="" *ngIf="checkViewMode('view')">
    <p><span>{{ attribute.key }}: </span> {{ attribute.value }}</p>
  </div>
